/* eslint-disable */
import { FC } from 'react';
import styles from '../../styles/components/controlVariations/ConfirmDownloadModal.module.css';
import QuestionMarkIcon from '../../assets/images/icon/download.png';

interface Props {
	onConfirm: () => void;
	onCancel: () => void;
}

const DownloadConfirmContent: FC<Props> = ({ onConfirm, onCancel }) => {
	return (
		<div className={styles.modal}>
			<div className={styles.iconWrapper}>
				<img src={QuestionMarkIcon} alt="Confirm" />
			</div>

			<h2 className={styles.title}>
				Are you sure you want to download this file?
			</h2>

			<div className={styles.actions}>
				<button className={styles.logoutButton} onClick={onConfirm}>
					Download
				</button>
				<button className={styles.cancelButton} onClick={onCancel}>
					Cancel
				</button>
			</div>
		</div>
	);
};

export default DownloadConfirmContent;
